import React, { useContext, useEffect, useRef, useState } from 'react';
import useAxiosPrivate from '../../../../Hooks/useAxiosPrivate';
import RightSvgIcon from '../../../../Svg/RightSvgIcon';
import AlertContext from '../../../../context/AlertContext';
import Chevdown from '../../../../Svg/ChevronDownSvg';
import Chevup from '../../../../Svg/ChevronUpSvg';
import Button from '../../../Button';
import { useParams } from 'react-router-dom';
import Tooltip from '../../../CommonComponents/Tooltip';
import { getDataFromStorage } from '../../../../util';




export default function RMtopic(Props) {

  const { reportTopics, setMid, setLpcid, setQns, setTotalmids, setIsGrandTotal, selectedChapters, setSelectedChapters, selectedModule, setSelectedModule,
        hoveredModule, setHoveredModule, appliedModules, setAppliedModules, selectedDropdown, setSelectedDropdown, openModuleDropdown, setOpenModuleDropdown } = useContext(AlertContext);
  
  // const [selectedModule, setSelectedModule] = useState(null);

  // const [openModuleDropdown, setOpenModuleDropdown] = useState(false);
  const [hoverPosition, setHoverPosition] = useState(null);

  const wrapperTopRef = useRef(null);
  const isHoverUpdating = useRef(false);

  const { lpid } = useParams();


  // const [hoveredModule, setHoveredModule] = useState(null);
  // const [appliedModules, setAppliedModules] = useState({}); // stores chapters applied for each module

  // 🟩 Handle Apply Button
  const handleApply = () => {

    if (!hoveredModule) return;

    // Save chapters for this module
    setAppliedModules({
    [hoveredModule.value]: selectedChapters,
  });

    // Mark this module as selected
    setSelectedModule(hoveredModule);

    const updatedModuleNode = {
      ...hoveredModule,
      children: selectedChapters,
    };    

    handleModule("chapter", updatedModuleNode);
    setOpenModuleDropdown(!openModuleDropdown);
  };

  /* reset the hover states */

    // useEffect(()=>{      
    //   if(sessionStorage.getItem("lastLpid") !== lpid){
    //     setHoveredModule(null);
    //     setOpenModuleDropdown(false);
    //     setSelectedModule(null);
    //     setSelectedChapters([]);
    //     setAppliedModules({});
    //   } else {
    //     sessionStorage.removeItem("lastLpid");
    //   }
    // },[lpid])

    useEffect(() => {
        const handleClickOutside = (event) => {    
          if (wrapperTopRef.current && !wrapperTopRef.current.contains(event.target)) {
            setOpenModuleDropdown(false); // Close the dropdown if click is outside
          }
        };

        if (openModuleDropdown) {
          document.addEventListener('mousedown', handleClickOutside);
        } else {
          document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, [openModuleDropdown]);

      useEffect(() => {
        if(isHoverUpdating.current) return;
        // When no chapters selected, remove the module automatically
        if (selectedModule && appliedModules[selectedModule.value] && selectedChapters.length === 0) {
          const newApplied = { ...appliedModules };
          delete newApplied[selectedModule.value];

          setAppliedModules(newApplied);
          setSelectedModule(null);
          setHoveredModule(null);

          handleRemoveModule(); // clear mid, lpcid, qns, etc.

          if (selectedDropdown) {
            Props.handleApplyBlockFilters(selectedDropdown, "mtopic");
            // setSelectedDropdown(null);
            setSelectedDropdown({
              college: null,
              status: null,
              branch: null
            });
          }
        }
      }, [selectedChapters]);


  const handleChapterToggle = (chapter) => {
  setSelectedChapters((prev) => {
    const isAlreadySelected = prev.some((c) => c.value === chapter.value);
    
    if (isAlreadySelected) {
      if(prev.filter((c) => c.value !== chapter.value).length === 0){
        isHoverUpdating.current = false;
      }
      // Remove chapter
      return prev.filter((c) => c.value !== chapter.value);
    } else {
      // Add chapter - but ensure we're only working within the current hovered module
      return [...prev, chapter];
    }
  });
};

  // Handle Module Data Calculation
  const handleModule = (from, selected) => {
    const actualSelectedQuestions = getActualSelectedQuestions(
      selected,
      reportTopics
    );    

    let mids = "",
      lpcids = "",
      qns = "",
      totalmids = "",
      isGrandTot = false;

    actualSelectedQuestions.forEach((q) => {
      if (q.isGrandTotal) {
        isGrandTot = true;
      } else if (q.isMtotal) {
        totalmids += `${q.value},`;
      } else if (q.isModule && !q.isTest) {
        mids += `${q.value},`;
      } else if (q.qnno) {
        qns += `${q.value},`;
        lpcids += `${q.lpcid},`;
      } else {
        lpcids += `${q.value},`;
      }
    });

    if (mids) mids = mids.slice(0, -1);
    if (lpcids) lpcids = lpcids.slice(0, -1);
    if (qns) qns = qns.slice(0, -1);
    if (totalmids) totalmids = totalmids.slice(0, -1);

    setMid(mids);
    setLpcid(lpcids);
    setQns(qns);
    setTotalmids(totalmids);
    setIsGrandTotal(isGrandTot);
  };

  const handleRemoveModule = () => {
    setMid("");
    setLpcid("");
    setQns("");
    setTotalmids("");
    setIsGrandTotal("");
  };

    const extractCheckedQuestions = (node, value) => {
    let result = [];

    let count = 0;

    if (node.children && node.children.length > 0) {
      let allQuestionsChecked = true;
      let childQuestions = [];

      for (const child of node.children) {        
        if (child.isQn) {
          if (child.checked) {
            childQuestions.push(child);
            count++;
          } else {
            allQuestionsChecked = false;
          }
        } else {
          const subResult = extractCheckedQuestions(child);          
          if (subResult.length > 0) {
            childQuestions.push(...subResult);
          } else {
            allQuestionsChecked = false;
          }
        }
      }

      if (
        node.isModule &&
        ((allQuestionsChecked && count === node.children.length) ||
          (!allQuestionsChecked && count === 0))
      ) {
        result.push(node);
      } else {
        result.push(...childQuestions);
      }
    } else {
      if (
        node.isQn === undefined &&
        (!node.label.includes("Total") || node.label.includes("Grand Total"))
      ) {
        result.push(node);
      }
    }

    return result;
  };

  const findNodeByValue = (nodes, value) => {
    for (const node of nodes) {
      if (node.value === value) {
        return node;
      }
      if (node.children) {
        const found = findNodeByValue(node.children, value);
        if (found) return found;
      }
    }
    return null;
  };

  const getActualSelectedQuestions = (selected, fullTree) => {
    const selectedQns = [];

    const selectedNodes = Array.isArray(selected) ? selected : [selected];

    selectedNodes.forEach((node) => {
      if (node.isQn) {
        selectedQns.push(node);
      } else {
        const matchInTree = node.children && node.children.length > 0
                            ? node
                            : findNodeByValue(fullTree, node.value);
        if (matchInTree) {
          const checkedQns = extractCheckedQuestions(matchInTree, node.value);          
          selectedQns.push(...checkedQns);
        }
      }
    });
    return selectedQns;
  };

  return (
    <div className="module_div" ref={wrapperTopRef}>
      {/* Module Dropdown */}
      <div className="rm_module_div">
        <button
          className={`rm_selected_module ${
            openModuleDropdown ? "mdactive" : ""
          }`}
          onClick={() => setOpenModuleDropdown(!openModuleDropdown)}
        >
          <span className='rm_selected_module_name'>{selectedModule ? selectedModule.label : "Select Module"}</span>
          <span>{openModuleDropdown ? <Chevup /> : <Chevdown />}</span>
        </button>

        {openModuleDropdown && (
          <div className="rm_module">
            {Props.data.map((mod, index) => {
              const isApplied = appliedModules[mod.value];
              const isSameSelected =
                selectedModule && selectedModule.value === mod.value;
              return (
                <div
                  key={index}
                  className="rm_module_label"
                  onMouseEnter={(e) => {
                    isHoverUpdating.current = true;
                    setHoveredModule(mod);
                    // restore previously applied chapters (if any)
                    setSelectedChapters(appliedModules[mod.value] || []);

                    const childRect = e.currentTarget.getBoundingClientRect();

                    // GET PARENT DROPDOWN WRAPPER POSITION
                    const parentRect = e.currentTarget
                      .closest(".rm_module_div")
                      .getBoundingClientRect();

                    // CORRECT RELATIVE POSITION
                    const relativeTop = childRect.top - parentRect.top;

                    setHoverPosition(relativeTop);
                  }}
                  onClick={() => {
                    // If clicking same selected module → deselect
                    if (isApplied && isSameSelected) {
                      const newApplied = { ...appliedModules };
                      delete newApplied[mod.value];
                      setAppliedModules(newApplied);
                      handleRemoveModule();
                      setSelectedModule(null);
                      setHoveredModule(null);
                      setSelectedChapters([]);
                      if(selectedDropdown){
                        Props.handleApplyBlockFilters(selectedDropdown, "mtopic");
                        // setSelectedDropdown(null);
                        setSelectedDropdown({
                          college: null,
                          status: null,
                          branch: null
                        });
                      }
                    } 
                    // else {
                    //   setSelectedModule(mod);
                    // }
                  }}
                >
                  <span className='rm_module_name'><Tooltip placement="top" title={mod.label} maxChars={24}>{mod.label}</Tooltip></span>
                  {isApplied ? (
                    <div>
                      <RightSvgIcon rmmodule={true} />
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Chapter Dropdown on Hover */}
      {hoveredModule &&
        openModuleDropdown &&
        hoveredModule.children &&
        hoveredModule.children.length > 0 && (
          <div className="rm_chapter_div"
          style={{
            position: "absolute",
            top: hoverPosition,
          }}  
          >
            <div className="rm_chapter">
              {hoveredModule.children.map((chapter, index) => {
                const isChecked = selectedChapters.some(
                  (c) => c.value === chapter.value
                );
                return (
                  <label key={index} className="rm_chapter_label">
                    <input
                      type="checkbox"
                      className="rm_chapter_checkbox"
                      checked={isChecked}
                      onChange={() => handleChapterToggle(chapter)}
                    />
                    <span className="rm_chapter_text"><Tooltip placement="top" title={chapter.label} maxChars={29}>{chapter.label}</Tooltip></span>
                  </label>
                );
              })}
              
            </div>
            <div className="rm_apply">
              <Button
                  className="rm_apply_btn"
                  size="sm"
                  disable={selectedChapters.length===0}
                  onClick={handleApply}
                  hierarchy={{
                    buttonText: "Apply",
                    type: "secondaryGrey",
                  }}
                />
            </div>
          </div>
        )}
    </div>
  )
}

